import { useEffect, useState } from 'react';
import { isEmpty, isNull } from 'lodash';

const CHATBOT_WIDGET_SRC = process.env.REACT_APP_CHATBOT_WIDGET_SRC ?? '';

const ChatbotWidgetScriptId = 'chatbot-widget-script';

// Everything the widget mounts outside our React root: two `body` containers and its stylesheet.
// It appends nothing else, so these are removed by id rather than by sweeping `body` for new nodes,
// which would also catch what browser extensions and GTM inject there.
const ChatbotWidgetSelectors = ['#helpjuice-widget-container', '#hj-lightbox', 'link[href*="widget.css"]'];

export const useChatbotWidget = (isEnabled: boolean) => {
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        if (isEnabled) setIsReady(true);
    }, [isEnabled]);

    useEffect(() => {
        if (!isReady || isEmpty(CHATBOT_WIDGET_SRC) || !isNull(document.getElementById(ChatbotWidgetScriptId))) return;

        const script = document.createElement('script');
        script.id = ChatbotWidgetScriptId;
        script.src = CHATBOT_WIDGET_SRC;
        document.body.appendChild(script);

        return () => {
            script.remove();
            ChatbotWidgetSelectors.forEach((selector) => document.querySelector(selector)?.remove());
        };
    }, [isReady]);
};
